import { render, staticRenderFns } from "./PriorityMark.vue?vue&type=template&id=23e74272&scoped=true&"
import script from "./PriorityMark.vue?vue&type=script&lang=js&"
export * from "./PriorityMark.vue?vue&type=script&lang=js&"
import style0 from "./PriorityMark.vue?vue&type=style&index=0&id=23e74272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e74272",
  null
  
)

export default component.exports